export var PeriodType;
(function (PeriodType) {
    PeriodType[PeriodType["YEAR"] = 0] = "YEAR";
    PeriodType[PeriodType["THREE_MONTH"] = 1] = "THREE_MONTH";
})(PeriodType || (PeriodType = {}));
export var PeriodAction;
(function (PeriodAction) {
    PeriodAction[PeriodAction["NEXT_PERIOD"] = 0] = "NEXT_PERIOD";
    PeriodAction[PeriodAction["PREVIOUS_PERIOD"] = 1] = "PREVIOUS_PERIOD";
})(PeriodAction || (PeriodAction = {}));
var Period = /** @class */ (function () {
    function Period(date, period) {
        var _this = this;
        this.changePeriod = function (action) {
            if (_this.period === PeriodType.YEAR) {
                return _this.loadYearDetails(action).getStartAndEndOfPeriod();
            }
            return _this.loadThreeMonthsDetails(action).getStartAndEndOfPeriod();
        };
        this.getHeaders = function () {
            var headers = [];
            var year = {};
            for (var i = 0; _this.period === PeriodType.YEAR ? i < 12 : i < 3; i += 1) {
                var newYearMonth = new Date(_this.yearMonth.getFullYear(), _this.yearMonth.getMonth() - i);
                // tslint:disable-next-line:strict-type-predicates
                year[newYearMonth.getFullYear()] !== undefined
                    ? (year[newYearMonth.getFullYear()] += 1)
                    : (year[newYearMonth.getFullYear()] = 1);
                var yearMonth = "".concat(newYearMonth.getFullYear(), "-").concat(newYearMonth.getMonth() + 1 < 10 ? '0' : '').concat(newYearMonth.getMonth() + 1);
                headers.splice(0, 0, yearMonth);
            }
            return [headers, year];
        };
        this.getStartAndEndOfPeriod = function () {
            var _a;
            var yearMonthFrom = new Date((_a = _this.yearMonth) !== null && _a !== void 0 ? _a : '');
            if (_this.period === PeriodType.THREE_MONTH) {
                yearMonthFrom.setMonth(yearMonthFrom.getMonth() - 2);
                if (yearMonthFrom.getMonth() < 0) {
                    yearMonthFrom.setMonth(yearMonthFrom.getMonth() + 12);
                    yearMonthFrom.setFullYear(yearMonthFrom.getFullYear() - 1);
                }
            }
            else {
                yearMonthFrom.setFullYear(yearMonthFrom.getFullYear() - 1);
                yearMonthFrom.setMonth(yearMonthFrom.getMonth() + 1);
            }
            var to = "".concat(_this.yearMonth.getFullYear(), "-").concat(_this.yearMonth.getMonth() + 1 < 10 ? '0' : '').concat(_this.yearMonth.getMonth() + 1);
            var from = "".concat(yearMonthFrom.getFullYear(), "-").concat(yearMonthFrom.getMonth() + 1 < 10 ? '0' : '').concat(yearMonthFrom.getMonth() + 1);
            return [from, to];
        };
        this.loadThreeMonthsDetails = function (action) {
            var newDate = new Date(_this.yearMonth);
            if (action === PeriodAction.NEXT_PERIOD) {
                if (newDate.valueOf() > +new Date().valueOf()) {
                    return new Period(newDate, _this.period);
                }
                newDate.setMonth(_this.yearMonth.getMonth() + 3);
                if (newDate.getMonth() >= 12) {
                    newDate.setMonth(newDate.getMonth() - 12);
                    newDate.setFullYear(_this.yearMonth.getFullYear() + 1);
                }
            }
            else {
                newDate.setMonth(_this.yearMonth.getMonth() - 3);
                if (newDate.getMonth() < 0) {
                    newDate.setMonth(newDate.getMonth() + 12);
                    newDate.setFullYear(_this.yearMonth.getFullYear() - 1);
                }
            }
            return new Period(newDate, _this.period);
        };
        this.loadYearDetails = function (action) {
            var newDate = new Date(_this.yearMonth);
            if (action === PeriodAction.NEXT_PERIOD) {
                if (newDate.valueOf() > +new Date().valueOf()) {
                    return new Period(newDate, _this.period);
                }
                newDate.setFullYear(_this.yearMonth.getFullYear() + 1);
            }
            else {
                newDate.setFullYear(_this.yearMonth.getFullYear() - 1);
            }
            return new Period(newDate, _this.period);
        };
        this.yearMonth = date;
        this.period = period;
    }
    Object.defineProperty(Period.prototype, "searchParams", {
        get: function () {
            var _a = this.getStartAndEndOfPeriod(), yearMonthFrom = _a[0], yearMonthTo = _a[1];
            return new URLSearchParams([
                ['year-month-from', String(yearMonthFrom)],
                ['year-month-to', String(yearMonthTo)],
            ]);
        },
        enumerable: false,
        configurable: true
    });
    return Period;
}());
export { Period };
